<template>
    <login-content class-name="m-register">
        <template slot="form">
            <div class="register-title">注册账号</div>
            <el-form ref="form" :model="forms" class="register-form" :rules="rules">
                <el-form-item prop="loginName">
                    <el-input v-model="forms.loginName" clearable placeholder="请设置用户名(6-18位数字字母组合，以字母开头)" autofocus autocomplete="off"/>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input v-model="forms.password" type="password" clearable  show-password placeholder="请输入密码(6-18位数字字母组合)" autocomplete="off" ></el-input>
                </el-form-item>
                <el-form-item prop="pwdAgain">
                    <el-input v-model="forms.pwdAgain" type="password" clearable show-password  placeholder="确认密码" autocomplete="off" ></el-input>
                </el-form-item>
                <el-form-item prop="mobile">
                    <el-input v-model="forms.mobile" clearable  placeholder="您的手机号" ></el-input>
                </el-form-item>
                <el-form-item prop="captchaId">
                    <el-input v-model="forms.captchaId"  placeholder="" class="hide"/>
                    <div id="captcha"></div>
                </el-form-item>
                <el-form-item prop="mobileCaptcha" class="mobileCaptcha">
                    <el-input v-model="forms.mobileCaptcha"  placeholder="请输入手机验证码"  class="mobileCaptcha-input"  clearable/>
                    <el-button class="sendCode" :disabled="disSend || (sendText != '发送验证码' && sendText != '重新发送验证码')" @click="sendCode" >{{sendText}}</el-button>
                </el-form-item>
                <el-form-item prop="remember" class="button_item">
                    <el-button type="primary" class="submit" :disabled="disOkBtn" @click="register">{{okText}}</el-button>
                </el-form-item>
            </el-form>
            <div class="to-login" @click="login">返回登录</div>
        </template>
    </login-content>
</template>

<script>
import loginContent from '@/components/loginContent'
import API from '@/fetch/api';
import { mobile } from '@/fetch/com'
import * as access from "@/config/access";
import { clearTimeout } from 'timers';

export default {
    data(){
        return {
            okText: '注册',
            pwd: true,
            pwdAgain: true,
            forms: {
                loginName: '',
                password: '',
                pwdAgain: '',
                mobile: '',
                captchaId: '',
                mobileCaptcha: ''
            },
            rules: {
                loginName: [
                    { required: true, message: '登录名不能为空', trigger: 'blur' },
                    { validator: this.validateName, trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' },
                    { validator: this.validatePwd, trigger: 'blur' }
                ],
                pwdAgain: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    { validator: this.validatePwd, trigger: 'blur' }

                ],
                mobile: [
                    { required: true, message: '手机号不能为空', trigger: 'blur' },
                    { validator: this.validateMobile, trigger: 'blur' }
                ],
                mobileCaptcha: [
                    { required: true, message: '验证码不能为空', trigger: 'blur' }
                ],
                captchaId: [
                    { required: true, message: '请进行滑块验证', trigger: 'blur' }
                ],
            },
            CaptchaIns: null,
            count: 60,
            timer: null,
            sendText: '发送验证码'
        }
    },
    components: {
        loginContent
    },
    computed:{
        disSend(){
            let bool = false;
            for(let key in this.forms){
                if(key != 'mobileCaptcha' && !this.forms[key]){
                    bool = true;
                }
            }
            return bool;
        },
        disOkBtn(){
            let bool = false;
            for(let key in this.forms){
                if(!this.forms[key]) bool = true;
            }
            return bool || this.okText != '注册';
        },
    },
    watch: {
        count(){
            this.sendText = this.count < 60 ? `${this.count}秒后重新发送` : '重新发送验证码';
        }
    },
    mounted(){
        // 初始化滑块验证
        this.initNECaptcha();
    },
    methods: {
        initNECaptcha(){
            let vm = this;
            initNECaptcha({
                // config对象，参数配置
                captchaId: '2e737a7bcb5a4b33ab90645a919cd6b8',
                element: '#captcha',
                mode: 'float',
                onReady(instance){
                    vm.CaptchaIns = instance;
                },
               /*  onload(instance){//初始化成功后得到验证实例instance，可以调用实例的方法
                    vm.CaptchaIns = instance;
                }, */
                onerror(err){//初始化失败后触发该函数，err对象描述当前错误信息

                },
                onVerify(err, data){ //验证码验证结束回调函数
                    if(err) return;
                    vm.$set(vm.forms, 'captchaId', data.validate);
                }
            });
        },
        validateName(rule, value, callback){
            let vm = this,
                reg = /^[a-zA-Z]{1}[0-9A-Za-z]{5,17}$/;
            if(!value || !value.trim()) {
                callback('请输入登录名');
            }else if(!reg.test(value)){
                callback('登录名应为6~18位数字字母组合，以字母开头');
            }else{
                callback();
            }
        },
        validatePwd(rule, value, callback){
            let vm = this,
                reg = /^[0-9a-zA-Z]{6,18}$/,
                field = rule.field == 'pwdAgain' ? 'password' : 'pwdAgain';
            if(!value || !value.trim()) {
                callback(`请${rule.field == 'pwdAgain' ? '再次' : ''}输入密码`);
            }else if(value.trim() && vm.forms.loginName.trim() && value.trim() == vm.forms.loginName){ //密码不能和登录名重复
                callback('密码不能和登录名重复');
            }else if(value.trim() && vm.forms[field].trim() && value.trim() != vm.forms[field].trim()){
                callback('两次输入的密码不一致');
            }else if(!reg.test(value)){
                callback('密码应为6~18位数字字母组合');
            }else{
                callback();
            }
        },
        validateMobile(rule, value, callback){
            if(!value || !value.trim()){
                callback('手机号不能为空');
            }else if(!mobile(value)){
                callback('请输入正确的手机号');
            }else{
                callback();
            }
        },
        // 刷新滑块
        refresh(){
            let vm = this;
            vm.CaptchaIns.refresh();
            vm.sended = false
            vm.clearTasks()
            vm.forms.captchaId = ''
        },
        sendCode(){
            let vm = this;
            // 如果发送过验证码
            if(vm.sended){
                vm.refresh();
                vm.$showAlert('请先进行滑块验证', 'warning');
                return;
            }
            // 校验手机格式
            this.$refs.form.validateField('mobile', (valid)=>{
                if(valid) return;
                //  清空原来的验证码
                this.forms.mobileCaptcha = ""
                API.http({url: '/mobile_captcha/send/v2', type: 'post',
                    params: {
                        mobile: vm.forms.mobile,
                        NECaptchaValidate: vm.forms.captchaId
                    },
                    postType: 'urlencoded',
                }).then(res => {
                    vm.sended = true;
                    // 开启倒计时
                    if(res.code == 200){
                        vm.count = 59;
                        vm.timer = setInterval(vm.openCountdown, 1000);
                        vm.$showAlert('验证码发送成功', 'success');
                        return;
                    }
                    vm.$showAlert(res.message || res.error ||  '发送验证码失败，请重试', 'error');
                    // 刷新滑块
                    vm.refresh();
                }).catch(res => {
                    // 刷新滑块
                    vm.refresh();
                    vm.$showAlert(res.message || '发送验证码失败，请重试', 'error');
                })
            });
        },
        clearTasks(){
            clearInterval(this.timer)
            this.timer = null
            this.count = 60
        },
        openCountdown(){
            let vm = this;
            vm.count--;
            // 清除定时器
            if(!(vm.count > 0 && vm.count < 60)){
                vm.clearTasks()
            }
        },
        register(){
            let vm = this;
            vm.$refs.form.validate((valid) => {
                if (!valid) return;
                vm.okText = '注册中...';
                API.http({url: '/merchant/register', type: 'post',
                    params: vm.forms,
                    postType: 'urlencoded',
                }).then(res => {
                    if(res.code == 200){
                        vm.$showAlert('注册成功', 'success');
                        vm.$router.push({ name: 'login' });
                        return;
                    }
                    vm.okText = '注册'
                    vm.$showAlert(res.message || res.error ||  '注册失败，请重试', 'error');
                    // 刷新滑块
                    vm.refresh();
                }).catch(res => {
                    vm.okText = '注册'
                    // 刷新滑块
                    vm.refresh();
                    vm.$showAlert(res.message || '注册失败，请重试', 'error');
                    return;
                })
            })
        },
        login(){
            this.$router.push({ name:  'login'});
        }
    }
    
}
</script>

<style lang="scss" scoped>
@import '../../style/variable';
    .m-register{
        .register-title{
            margin-bottom: 30px;
            text-align: center;
            font-size: 34px;
            font-family: Microsoft YaHei;
            color: $c4;
        }
        .register-form{
            width: 100%;
            .mobileCaptcha{
                &-input{
                    margin-right: 7%;
                    width: 48%;
                }
                .sendCode{
                    width: 45%;
                    // cursor: pointer;
                }
            }
            .iconfont{
                font-size: $fs_16;
            }
            .button_item{
                margin-top: 20px;
                .submit{
                    width: 100%;
                    padding: 0;
                    height: 40px;
                    line-height: 40px;
                    background-color: $c4;
                    border-color: $c4;
                    &.is-disabled{
                        background-color: $btn-login-dis;
                        border-color: $btn-login-dis;
                    }
                }
            }
        }
        .to-login{
            // margin-top: 20px;
            color: $c4;
            text-align: center;
            font-size: 12px;
            text-decoration: underline;
            cursor: pointer;
        }
    }
</style>   